import { render } from "./OrderLocked.vue?vue&type=template&id=773f8350&scoped=true"
import script from "./OrderLocked.vue?vue&type=script&lang=js"
export * from "./OrderLocked.vue?vue&type=script&lang=js"

import "./OrderLocked.vue?vue&type=style&index=0&id=773f8350&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773f8350"]])

export default __exports__